<div class="modal-container" *ngIf="opened">
  <div class="modal-backdrop" (click)="close()"></div>
  
  <div class="modal-content" style="z-index: 11000;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Estudios del paciente {{patientName}}</h3>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <div class="modal-body">
      <table mat-table [dataSource]="historicStudyList" class="table" matSort 
             cdkDropList cdkDropListOrientation="horizontal">
        
        <!-- Columna StudyDate -->
        <ng-container matColumnDef="StudyDate">
          <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag mat-sort-header>Fecha Recepción</th>
          <td mat-cell *matCellDef="let study">
            <span>{{study.studyDate | date:'dd/MM/yyyy - HH:mm'}}</span>
          </td>
        </ng-container>
        
        <!-- Columna StudyDescription -->
        <ng-container matColumnDef="StudyDescription">
          <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag mat-sort-header>Descripción</th>
          <td mat-cell *matCellDef="let study">
            <span>{{study.studyDescription}}</span>
          </td>
        </ng-container>

        <!-- Columna Status -->
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag>Estado</th>
          <td mat-cell *matCellDef="let study">
            <span *ngIf="isStudyObtaining(study)">Recuperando...</span>
            <span *ngIf="!isStudyObtaining(study) && isStudyDeleted(study)" >Preparado para recuperar</span>
            <span *ngIf="!isStudyObtaining(study) && isStudyReady(study)">Disponible</span>
          </td>
        </ng-container>
        <span class="material-icons md-18" aria-hidden="true" style="color: #1DDF99;">
                    cloud_download
        </span>
        <!-- Columna Actions -->
        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag>Acciones</th>
          <td mat-cell *matCellDef="let study">
            <div *ngIf="study!=null">
              <!-- Si el estudio está eliminado, mostrar botón de recuperar -->
              <span *ngIf="isStudyDeleted(study) && !isStudyObtaining(study)" 
                    class="material-icons ms-2" 
                    aria-hidden="true"
                    title="Recuperar estudio"
                    (click)="$event.stopPropagation();onClickObtainStudy(study);"
                    style="cursor: pointer;">
                cloud_download
              </span>

              <!-- Si el estudio está siendo recuperado, mostrar indicador -->
              <div *ngIf="isStudyObtaining(study)" class="spinner-border text-light" 
                style="width: 1.5rem; height: 1.5rem;" role="status">
                <span class="visually-hidden"></span>
              </div>

              <!-- Si el estudio está disponible, mostrar todas las acciones -->
              <ng-container *ngIf="isStudyReady(study)">
                <span class="ps-icons icon-book-digital ms-2" 
                      title="Ver Book"
                      (click)="$event.stopPropagation();onClickSeeBook(study);"
                      style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
                      [class.disabled]="!study.hasAccessibleBook">
                </span>

                <span class="prp-icons icon-see ms-2" 
                      title="Abrir visor"
                      (click)="$event.stopPropagation();onClickOpenVisor(study);"
                      style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
                      [class.disabled]="!study.hasDCMs">
                </span>

                <span *ngIf="downloading!=null && downloading.studyUID==study.studyUID; else DownloadIcon" 
                      class="ms-2" 
                      style="font-size: 12px; cursor: pointer; color: #f2c63d; display: inline-block; width: 30px; text-align: center;"
                      title="Descargando...">
                  {{downloading.percentage | number:'1.0'}}%
                </span>
                <ng-template #DownloadIcon>
                  <span class="visor-icons icon-download ms-2" 
                        title="Descargar estudio"
                        (click)="$event.stopPropagation();onClickDownloadStudy(study);"
                        style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
                        [class.disabled]="!study.hasDCMs">
                  </span>
                </ng-template>

                <span class="prp-icons icon-pdf ms-2" 
                      title="Informes"
                      (click)="$event.stopPropagation();onClickOpenReportPreview(study);"
                      style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
                      [class.disabled]="!study.hasReports">
                </span>
              </ng-container>
            </div>
          </td>
        </ng-container>
        
        <!-- Filas -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let study; columns: displayedColumns;"></tr>
      </table>
      
      <!-- Empty State -->
      <div class='w-100 h-50 d-flex justify-content-center align-items-center'
           style="background-color: rgba(128, 128, 128, 0.192);" 
           *ngIf='isEmpty'>
        <div class="d-flex justify-content-center w-100">
          <h4>No se encontraron estudios para el paciente</h4>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="close()">Cerrar</button>
    </div>
  </div>
</div>

<app-report-viewer></app-report-viewer>

